// extracted by mini-css-extract-plugin
export default {"body":"FarmConstruction_body__A9aZP","title":"FarmConstruction_title__QW7yN","farm":"FarmConstruction_farm__tPbpJ","con":"FarmConstruction_con__1HbQD"};